import { Journey, journeyFromJson } from './Journey';

export type UserJourneyStatus = 'active' | 'paused' | 'completed' | 'abandoned';

export interface StepCompletion {
  stepId: string;
  completedAt: Date;
  workoutId?: string | null;
}

export interface UserJourney {
  id?: string | null;
  userId: string;
  sourceJourneyId: string | null;
  journey: Journey;
  status: UserJourneyStatus;
  completedSteps: StepCompletion[];
  currentStepIndex: number;
  startedAt: Date;
  lastPracticedAt?: Date | null;
  completedAt?: Date | null;
}

function stepCompletionFromJson(json: Record<string, unknown>): StepCompletion {
  return {
    stepId: json['stepId'] as string,
    completedAt: json['completedAt'] as Date,
    workoutId: (json['workoutId'] as string | null | undefined) ?? null,
  };
}

export function userJourneyFromJson(json: Record<string, unknown>): UserJourney {
  return {
    id: (json['id'] as string | null) ?? null,
    userId: json['userId'] as string,
    sourceJourneyId: (json['sourceJourneyId'] as string | null) ?? null,
    journey: journeyFromJson(json['journey'] as Record<string, unknown>),
    status: json['status'] as UserJourneyStatus,
    completedSteps: ((json['completedSteps'] as Record<string, unknown>[] | undefined) ?? []).map(stepCompletionFromJson),
    currentStepIndex: json['currentStepIndex'] as number,
    startedAt: json['startedAt'] as Date,
    lastPracticedAt: (json['lastPracticedAt'] as Date | null | undefined) ?? null,
    completedAt: (json['completedAt'] as Date | null | undefined) ?? null,
  };
}
